import React from 'react'

const TwitterMessage = ({twitterEmbedHTML}) => {
  return (
    <article className="slds-card">
      <div className="slds-card__header slds-grid">
        <header className="slds-media slds-media--center slds-has-flexi-truncate">
          <div className="slds-media__body">
          </div>
        </header>
      </div>
      <div className="slds-card__body">
        <div className="slds-grid slds-m-horizontal--medium">
          <div className="slds-col slds-has-flexi-truncate">
            <div className="slds-text-title--caps slds-line-height--reset" style={{zindex: '-1'}} >
              <div id="twitter-embed" dangerouslySetInnerHTML={{__html: twitterEmbedHTML}} />
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}

export default TwitterMessage